export default __webpack_public_path__ + "static/media/dont_stop_me_now.3ad38bc4.jpg";